import { Injectable } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import { PersonalisedPromotion } from '@cureskin/api-client/src/server-api/api';

@Injectable({ providedIn: 'root' })
export class PersonalisedPromotionsService {
  constructor(
    private readonly conn: ConnectionService,
  ) {}

  loadPersonalisedPromotions(): Promise<PersonalisedPromotion[]> {
    return this.conn.getPersonalisedPromotions();
  }
}
